import { Report } from '../../types/report.types';
import { MIDASProject } from '../../types/project.types';
import { createReportId } from '../../types';
import { checkReportNameDuplicate } from './duplicateNameChecker';

/**
 * 新しいレポートを作成
 */
export function createNewReport(
  name: string,
  description?: string
): Report {
  const now = new Date().toISOString();

  return {
    id: createReportId(`report-${crypto.randomUUID()}`),
    name,
    description: description || `New report created at ${new Date().toLocaleString()}`,
    content: '', // Markdown本文（空で初期化）
    elements: {}, // 要素辞書（空で初期化）
    reportSettings: {
      contentWidth: 800,
      defaultElementMargin: 16,
      backgroundColor: '#ffffff',
      autoSave: false,
      autoSaveInterval: 5
    },
    metadata: {
      createdAt: now,
      lastModified: now,
      tags: [],
      sharing: {
        isPublic: false,
        permissions: ['view', 'edit']
      }
    }
  };
}

/**
 * レポート名の重複をチェック
 */
export function checkReportNameDuplicateHelper(
  name: string,
  project: MIDASProject | null
) {
  if (!project) {
    return {
      isDuplicate: false,
      duplicateType: 'report' as const,
      originalName: name
    };
  }
  return checkReportNameDuplicate(name, project);
}

/**
 * プロジェクトを更新（フロントエンドとバックエンドの両方）
 */
export async function updateProjectWithReport(
  updatedProject: MIDASProject,
  onProjectUpdate?: (project: MIDASProject) => void
): Promise<void> {
  // フロントエンドの状態を更新
  if (onProjectUpdate) {
    onProjectUpdate(updatedProject);
  }
}